import {
  Box,
  Collapse,
  HStack,
  IconButton,
  useDisclosure,
  VStack,
  Text,
} from "@chakra-ui/react";
import { ChevronDownIcon, ChevronUpIcon } from "@chakra-ui/icons";

// Logs section component
interface LogsSectionProps {
  logs: string[];
}

const LogsSection: React.FC<LogsSectionProps> = ({ logs }) => {
  const { isOpen, onToggle } = useDisclosure();

  return (
    <Box>
      <HStack align="center" mb={0}>
        <Text fontWeight="semibold" fontSize="sm" mb={0}>
          System Logs ({logs?.length})
        </Text>
        <IconButton
          aria-label={isOpen ? "Hide logs" : "Show logs"}
          icon={isOpen ? <ChevronUpIcon /> : <ChevronDownIcon />}
          size="xs"
          variant="ghost"
          onClick={onToggle}
        />
      </HStack>
      <Collapse in={isOpen}>
        <Box
          maxH="200px"
          overflowY="auto"
          bg="gray.50"
          border="1px"
          borderColor="gray.200"
          borderRadius="md"
          p={2}
        >
          <VStack spacing={1} align="stretch">
            {logs?.map((log, index) => (
              <Text
                key={index}
                fontSize="xs"
                fontFamily="mono"
                color="gray.700"
                mb={0}
                whiteSpace="pre-wrap"
                wordBreak="break-word"
                align="left"
              >
                {log}
              </Text>
            ))}
          </VStack>
        </Box>
      </Collapse>
    </Box>
  );
};

export default LogsSection;
